/**
 * The red "LIVE NOW" pill of a congress in progress, the same signal as the
 * mobile congress card. Its words are congress content: the caller passes them
 * from `resolveCongressCountdownCopy`.
 */
export function DesktopCongressLiveBadge({
  label,
}: {
  label: string;
}): React.JSX.Element {
  return (
    <span className="inline-flex shrink-0 items-center gap-1.5 rounded-md bg-ds-strawberry-600 p-2 font-dm-sans text-desktop-caption leading-none font-medium text-ds-white uppercase">
      <span aria-hidden className="size-1.5 rounded-full bg-ds-white" />
      {label}
    </span>
  );
}
